module.exports = __webpack_public_path__ + "img/calendarIL2.8b38964f.jpg";